import type { RelationQuery } from '#layers/data-model/types/field-selection';
import type { FilterOperandNormalizationContext } from './filters/normalize-filter-operands-for-backend';
import { resolveFieldSelectionDefaults } from './field-selection/resolve-field-selection-defaults';
import { toApplicableFilter, unwrapSingleTermGroups } from './filters';
import { hasIncludeFilter, normalizeFilterOperandsForBackend, normalizeIncludeFilterOperandsForBackend } from './filters/normalize-filter-operands-for-backend';

/** Prepare structured wire values before encoding a query or rendering a code snippet. */
export function normalizeQueryForBackend(
	query: RelationQuery,
	context: FilterOperandNormalizationContext,
): RelationQuery & { fields: string[] } {
	const { filter, ...options } = query;
	const selection = resolveFieldSelectionDefaults(options);
	const applicableFilter = filter ? toApplicableFilter(filter) : undefined;
	// A read filter accepts `_and`/`_or` only where it declares them; a one-term group is its term.
	const sentFilter = applicableFilter ? unwrapSingleTermGroups(applicableFilter) : undefined;
	const include = selection.include;

	return {
		...options,
		...selection,
		fields: selection.fields ?? ['*'],
		...(sentFilter ? { filter: normalizeFilterOperandsForBackend(sentFilter, context) } : {}),
		...(include && hasIncludeFilter(include) && context.schemaCollection
			? { include: normalizeIncludeFilterOperandsForBackend(include, context) }
			: {}),
	};
}
